<aside class="sidebar" [class.collapsed]="sidebarService.isCollapsed()">
  <div class="logo">
    @if (!sidebarService.isCollapsed()) {
      <img src="assets/images/logos/company_logo_with_name.svg" alt="Company Logo" />
    } @else {
      <img src="assets/images/logos/company_logo_icon.svg" alt="Company Logo" />
    }
  </div>

  <ul class="menu">
    @for (item of navItems(); track item.route) {
      <li
        [routerLink]="item.route"
        routerLinkActive="active-link"
        [pTooltip]="sidebarService.isCollapsed() ? item.label : ''">
        <span class="flex items-center gap-4">
          <i class="pi {{ item.icon }} link-icon"></i>
          @if (!sidebarService.isCollapsed()) {
            <span class="label">{{ item.label }}</span>
          }
        </span>
      </li>
    }
  </ul>

  <div class="profile-section" [ngClass]="{'!px-2': sidebarService.isCollapsed()}">
    <div class="profile-settings" [ngClass]="{'!p-1 justify-center': sidebarService.isCollapsed()}">
      <div
        class="user-profile-circle border border-gray-200 !text-xs flex items-center justify-center">
        {{ getUserInitial() }}
      </div>
      @if (!sidebarService.isCollapsed()) {
        <div class="profile-info">
          <span class="profile-name">{{ auth.admin()?.name }}</span>
          <span class="profile-email">{{ auth.admin()?.email }}</span>
        </div>
      }
    </div>

    @if (!sidebarService.isCollapsed()) {
      <button class="logout-btn" type="button" (click)="onLogOut()">
        <i class="pi pi-sign-out text-sm! font-medium!"></i>
        Logout
      </button>
    }
  </div>
</aside>
